import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import GoogleMap from './GoogleMap';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/contact.js';

function Contact() {
    useEffect(() => {
        const form = document.getElementById("form_contact");
        const name = document.getElementById("contact_name");
        const email = document.getElementById("contact_email");
        const subject = document.getElementById("contact_subject");
        const message = document.getElementById("contact_message");

        if (!form) return;

        const formSubmit = (e) => {
            e.preventDefault();

            const nameValue = name.value.trim();
            const emailValue = email.value.trim();
            const subjectValue = subject.value.trim();
            const messageValue = message.value.trim();

            if (nameValue === "") {
                setError(name, "Name can't be blank");
            } else {
                setSuccess(name);
            }

            if (emailValue === "") {
                setError(email, "Email can't be blank");
            } else if (!isEmail(emailValue)) {
                setError(email, "Enter a valid email address");
            } else {
                setSuccess(email);
            }

            if (subjectValue === "") {
                setError(subject, "Subject can't be blank");
            } else {
                setSuccess(subject);
            }

            if (messageValue === "") {
                setError(message, "Message can't be blank");
            } else {
                setSuccess(message);
            }
        };

        function setError(input, message) {
            const formControl = input.parentElement;
            const errorMsg = formControl.querySelector(".contact_input-msg");
            formControl.className = "form-control text-left error";
            errorMsg.innerText = message;
        }

        function setSuccess(input) {
            const formControl = input.parentElement;
            const errorMsg = formControl.querySelector(".contact_input-msg");
            formControl.className = "form-control text-left success";
            if (errorMsg) errorMsg.innerText = "";
        }

        function isEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
        }

        form.addEventListener("submit", formSubmit);

        return () => {
            form.removeEventListener("submit", formSubmit);
        };
    }, []);

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper contact-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Breadcrumb */}
                <BreadcrumbBox title="Contact Us" />

                {/* Contact Area */}
                <section className="contact-area">
                    <Container>
                        <Row>
                            <Col md="5">
                                <div className="contact-box-title">
                                    <h4>Contact Information</h4>
                                </div>

                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-map-marker"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Our Location</h5>
                                        <p>near Golden Future Library, Chow Mandi, Chand Puri Nagar, Roorkee, Uttarakhand 247667</p>
                                    </div>
                                </div>

                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-envelope-open"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Email Address</h5>
                                        <p>info@erptechpro.in</p>
                                    </div>
                                </div>

                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-phone"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Phone Number</h5>
                                        <p>+91 7599020021,
                                            +91 8791551455</p>
                                    </div>
                                </div>

                                <div className="contact-icon-box d-flex">
                                    <div className="icon">
                                        <i className="las la-clock"></i>
                                    </div>
                                    <div className="box-content">
                                        <h5>Office Hours</h5>
                                        <p>Monday - Saturday<br />9:00 AM - 5:00 PM</p>
                                    </div>
                                </div>

                                <div className="contact-social">
                                    <ul className="social list-unstyled list-inline">
                                        <li className="list-inline-item">
                                            <a href="https://www.facebook.com/61580941010197/" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="https://wa.me/917599020021" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-whatsapp"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="https://youtube.com/@erptechpro?si=nhu16ox6xv46Kdx9" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-youtube"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href="https://www.instagram.com/erptechproofficial?igsh=MTN2NG9xbmJ0MTY1dg==" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-instagram"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </Col>

                            <Col md="7">
                                <div className="contact-form">
                                    <div className="form-title">
                                        <h4>Get In Touch</h4>
                                        <p>
                                            We are here to answer your questions about admissions, courses,
                                            campus facilities, and student support services.
                                        </p>
                                    </div>

                                    <div className="form-box mt-5">
                                        <form id="form_contact" className="form">
                                            <Row>
                                                <Col md="6">
                                                    <p className="form-control text-left">
                                                        <input type="text" placeholder="Full Name" id="contact_name" />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>

                                                <Col md="6">
                                                    <p className="form-control text-left">
                                                        <input type="email" placeholder="Email Address" id="contact_email" />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>

                                                <Col md="12">
                                                    <p className="form-control text-left">
                                                        <input type="text" placeholder="Subject" id="contact_subject" />
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>

                                                <Col md="12">
                                                    <p className="form-control text-left">
                                                        <textarea
                                                            name="message"
                                                            id="contact_message"
                                                            placeholder="Write Your Message"
                                                        ></textarea>
                                                        <span className="contact_input-msg"></span>
                                                    </p>
                                                </Col>

                                                <Col md="12">
                                                    <button type="submit">Send Message</button>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    {/* Google Map */}
                    <GoogleMap />
                </section>

                {/* Footer 2 */}
                <FooterTwo />
            </div>
        </Styles>
    )
}

export default Contact;